export const SET_LOCALE = 'i18n/SET_LOCALE';

export const setLocale = (locale) => ({
  type: SET_LOCALE,
  locale
});
